export default __webpack_public_path__ + "static/media/group-626@2x.5a85314e.png";